export const WaterTemperatureIconGray = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08691 29.5824C3.70939 31.0765 5.44873 31.8246 7.30596 31.8246C10.0918 31.8246 10.7586 29.5813 13.5496 29.5813C16.3417 29.5813 17.4415 31.8246 19.6357 31.8246C21.8289 31.8246 23.5161 29.5813 25.7031 29.5813C27.89 29.5813 28.875 32.025 31.6744 31.9999C33.54 31.9843 35.3826 31.1276 37.2033 29.4321"
      stroke="#9B9B9B"
      strokeWidth="1.5"
    />
    <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="21" width="40" height="8">
      <path
        d="M16.6035 28.1726L0 28.1716V21.9112H11.6338C12.0804 24.7597 14.0075 27.1177 16.6035 28.1726ZM39.6489 21.9112V28.1716L22.7199 28.1726C25.3158 27.1177 27.243 24.7597 27.6896 21.9102L39.6489 21.9112Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M2.08691 24.8475C3.70939 26.3416 5.44873 27.0877 7.30596 27.0877C10.0918 27.0877 10.7586 24.8464 13.5496 24.8464C16.3417 24.8464 17.4415 27.0877 19.6357 27.0877C21.8289 27.0877 23.5161 24.8464 25.7031 24.8464C27.89 24.8464 28.875 27.288 31.6744 27.264C33.54 27.2473 35.3826 26.3917 37.2033 24.6952"
        stroke="#9B9B9B"
        strokeWidth="1.5"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7523 0C21.285 0 22.5267 1.24164 22.5267 2.77334V14.4134C24.8816 15.4986 26.5166 17.8796 26.5166 20.6425C26.5166 24.4269 23.448 27.4955 19.6626 27.4955C15.8771 27.4955 12.8096 24.4269 12.8096 20.6414C12.8096 17.8796 14.4435 15.4986 16.7985 14.4134V2.77334C16.7974 1.24164 18.0391 0 19.5708 0H19.7523Z"
      fill="#EBEBEB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9953 3.66113V15.7541C23.1468 16.3384 24.7275 18.3052 24.7275 20.6413C24.7275 23.4397 22.4592 25.707 19.6619 25.707C16.8645 25.707 14.5962 23.4397 14.5962 20.6413C14.5962 18.3052 16.1769 16.3384 18.3284 15.753V3.66218H20.9953V3.66113Z"
      fill="#BFBFBF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3286 7.51855H22.17V8.56195H17.3286V7.51855ZM17.3286 12.1272H22.17V13.1706H17.3286V12.1272Z"
      fill="#D8D8D8"
    />
  </svg>
);
